import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { selectLocationPathname, selectLocationSearch, useLocationSelector } from '@shared/core/router.helper/useLocationSelector';
import { useCardsRouterContext } from '@apps/card/Card.routes';
import { isBareGalleryUrl } from './galleryParams';

/**
 * The client half of the public gallery SSR gate (PRNT-5494); mirrors `publicGallerySsrGate.ts`.
 * The flag is read only once the URL qualifies: reading it records an exposure, and an admin or
 * filtered visitor can never see the variant.
 */
export const useIsPublicGallerySsr = (): boolean => {
  const { isPublicShopRoute } = useCardsRouterContext();
  const pathname = useLocationSelector(selectLocationPathname);
  const search = useLocationSelector(selectLocationSearch);
  const isEligible = isPublicShopRoute && isBareGalleryUrl(pathname, search);
  const [isEnabled] = useIsFeatureEnabled('printPublicGallerySsr', { skip: !isEligible });
  return isEligible && isEnabled;
};
